export const AnomalyStatusEnum = {
    ALERT_ABOVE: 'ALERT_ABOVE',
    WARNING_ABOVE: 'WARNING_ABOVE',
    CLEAR: 'CLEAR',
    WARNING_BELOW: 'WARNING_BELOW',
    ALERT_BELOW: 'ALERT_BELOW'
}